define(['angular'], function (angular) {
    return angular.module('announcementServices', []).factory('Announcements', [
        '$http',
        '$rootScope',
        function ($http, $rootScope) {
            var announcements = false;
            return {
                close: function () {
                    $http({
                        method: 'PUT',
                        url: $rootScope.Routing.generate('announcement_viewed'),
                    }).then(function (response) {
                        announcements.pop();
                        if (announcements.length == 0) {
                            /* This exists to handle an apparent bug in
                             * Chrome that is not re-drawing the page after
                             * the block is closed.
                             */
                            $('#announcements').hide();
                        }
                    });
                },
                get: function () {
                    if (announcements === false) {
                        announcements = [];
                        $http({
                            method: 'GET',
                            url: $rootScope.Routing.generate('announcement'),
                        }).then(function (response) {
                            if (response.data) {
                                announcements.push(response.data);
                            }
                        });
                    }

                    return announcements;
                },
            };
        },
    ]);
});
